import {Action} from '@ngrx/store';

export enum IamFoundationActionsTypes {
  UPDATE_IAM_FOUNDATION_STATUS = '[iam foundation action] update IAM Foundation feature status'
}

export class IamFoundationUpdateStatus implements Action {
  readonly type = IamFoundationActionsTypes.UPDATE_IAM_FOUNDATION_STATUS;

  constructor(public payload: { status: boolean }) {
  }
}

export type IamFoundationActions = IamFoundationUpdateStatus;
